const objIdMap = new WeakMap();
let objCount = 0;

const getObjId = (obj) => {
  if (!objIdMap.has(obj)) {
    objIdMap.set(obj, ++objCount);
  }

  return objIdMap.get(obj);
};

export {
  getObjId,
};
